import { render, staticRenderFns } from "./AppointmentTimer.vue?vue&type=template&id=00721b70&scoped=true"
import script from "./AppointmentTimer.vue?vue&type=script&lang=js"
export * from "./AppointmentTimer.vue?vue&type=script&lang=js"
import style0 from "./AppointmentTimer.vue?vue&type=style&index=0&id=00721b70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00721b70",
  null
  
)

export default component.exports